module.exports = __webpack_public_path__ + "img/perceval.a1c972d7.png";